import React from 'react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import AppointmentStatusPill from './AppointmentStatusPill';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import { ListRowSkeletonStack } from '../loading/skeletons';
import './styles/PendingConfirmationsCard.css';
import './styles/TodayAppointmentsCard.css';
import './board/OverviewBoard.css';

const PendingConfirmationsCard = ({ pendingAppointments, loading = false, onViewAll, getServiceName, onAppointmentClick }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/appointments', { state: { initialTab: 2 } });
  };

  return (
    <div className="pending-confirmations-container overview-board">
      <OverviewBoardHeader
        eyebrow="Pending"
        title="Confirmation"
        count={loading ? 'Loading appointments' : `${pendingAppointments.length} waiting`}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all pending appointments"
      />

      <div className="overview-board__body">
        {loading ? (
          <ListRowSkeletonStack rows={4} variant="compact" label="Loading pending appointments" />
        ) : pendingAppointments.length > 0 ? (
          <ul className="today-label-table">
            {pendingAppointments.slice(0, 4).map((appointment, index) => {
              const when = new Date(appointment.dateTime);
              const timeLabel = Number.isNaN(when.getTime()) ? '—' : format(when, 'h:mm');
              const periodLabel = Number.isNaN(when.getTime()) ? '' : format(when, 'a');

              return (
                <li key={appointment.id || index} className="today-label-table__item">
                  <button
                    type="button"
                    className="today-label-row"
                    onClick={() => onAppointmentClick && onAppointmentClick(appointment)}
                  >
                    <div className="today-label-time">
                      <span className="today-label-time__clock">{timeLabel}</span>
                      {periodLabel ? <span className="today-label-time__period">{periodLabel}</span> : null}
                    </div>
                    <div className="today-label-body">
                      <div className="today-label-body__top">
                        <span className="today-label-name">{appointment.clientName || 'Client'}</span>
                        <AppointmentStatusPill status="pending" />
                      </div>
                      <span className="today-label-service">
                        {appointment.service?.name || appointment.serviceName || 'No service specified'}
                      </span>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="pending-confirmations-empty">
            <p>No appointments pending confirmation</p>
          </div>
        )}
      </div>

      {pendingAppointments.length > 4 && (
        <div className="pending-confirmations-footer">
          <p onClick={handleViewAll}>
            {pendingAppointments.length - 4} more pending appointments
          </p>
        </div>
      )}
    </div>
  );
};

export default PendingConfirmationsCard;
